"use strict";
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var mat4 = require('gl-matrix/src/gl-matrix/mat4');
function transformDirection(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = m[0] * x + m[4] * y + m[8] * z;
    out[1] = m[1] * x + m[5] * y + m[9] * z;
    out[2] = m[2] * x + m[6] * y + m[10] * z;
    return vec3.normalize(out, out);
}
exports.transformDirection = transformDirection;
var x = vec3.create();
var y = vec3.create();
var z = vec3.create();
// From three.js
function lookAt(out, eye, target, up) {
    vec3.sub(z, eye, target);
    vec3.normalize(z, z);
    if (vec3.squaredLength(z) === 0) {
        z[2] = 1;
    }
    vec3.cross(x, up, z);
    vec3.normalize(x, x);
    if (vec3.squaredLength(x) === 0) {
        z[2] += 0.0001;
        vec3.cross(x, up, z);
        vec3.normalize(x, x);
    }
    vec3.cross(y, z, x);
    out[0] = x[0];
    out[4] = y[0];
    out[8] = z[0];
    out[1] = x[1];
    out[5] = y[1];
    out[9] = z[1];
    out[2] = x[2];
    out[6] = y[2];
    out[10] = z[2];
    return out;
}
exports.lookAt = lookAt;
function perspective(out, fovy, near, far, viewWidth, viewHeight, offsetX, offsetY) {
    var height = 2 * near * Math.tan(fovy / 2);
    var width = viewWidth / viewHeight * height;
    var top = height / 2 - offsetY * height / viewHeight;
    var left = -width / 2 + offsetX * width / viewWidth;
    return mat4.frustum(out, left, left + width, top - height, top, near, far);
}
exports.perspective = perspective;
//# sourceMappingURL=mat4.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/utils/mat4.js
 ** module id = 120
 ** module chunks = 0
 **/